import _slicedToArray from "/codebuild/output/src908941260/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var MAX_SUGGESTIONS = 5;
/**
 * Given [ A, B, C ] return ' Did you mean A, B, or C?'.
 */

export function didYouMean(firstArg, secondArg) {
  var _ref = secondArg ? [firstArg, secondArg] : [undefined, firstArg],
      _ref2 = _slicedToArray(_ref, 2),
      subMessage = _ref2[0],
      suggestionsArg = _ref2[1];

  var message = ' Did you mean ';

  if (subMessage) {
    message += subMessage + ' ';
  }

  var suggestions = suggestionsArg.map(function (x) {
    return "\"".concat(x, "\"");
  });

  switch (suggestions.length) {
    case 0:
      return '';

    case 1:
      return message + suggestions[0] + '?';

    case 2:
      return message + suggestions[0] + ' or ' + suggestions[1] + '?';
  }

  var selected = suggestions.slice(0, MAX_SUGGESTIONS);
  var lastItem = selected.pop();
  return message + selected.join(', ') + ', or ' + lastItem + '?';
}